// 機能: 研修生スケジュール画面の制御
// 概要: 「選択課題のみ」のチェックボックスをONにすると、選択課題のみを一覧に表示する。
//       「選択課題のみ」のチェックボックスをOFFにすると、全ての課題を一覧に表示する。
document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.querySelector('.js-user-practices-only__trigger')
  const table = document.querySelector('.js-userSchedules')

  if (!checkbox || !table) return

  const toggleRows = () => {
    table.querySelectorAll('.admin-table__items > tr.is-retired').forEach((element) => {
      if (checkbox.checked) {
        element.classList.add('is-hidden')
      } else {
        element.classList.remove('is-hidden')
      }
    })
  }

  // 初期表示時に実行
  toggleRows()

  // チェックボックスクリック時に実行
  checkbox.addEventListener('click', toggleRows)
})
